import { tr } from "../../i18n";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import AuthLayout, { Field, inputCls } from "./AuthLayout";
import { api, apiError } from "../../auth/AuthContext";
export default function ForgotPassword() {
  const {
    lang = "en"
  } = useParams();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", {
        email
      });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title={tr("Forgot your password?")} subtitle={tr("Enter your email address and we'll send you a secure link to reset your password.")}>
      {sent ? <div data-testid="forgot-success">
          <p className="border border-esaia-blue/30 bg-esaia-blue/5 p-4 text-sm leading-relaxed text-esaia-ink">{tr("If an account exists for this email address, you will receive a password reset link.")}{" "}</p>
          <Link to={`/${lang}/login`} className="mt-6 block w-full bg-esaia-blue px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-esaia-dark" data-testid="return-to-login">{tr("Return to Login")}{" "}</Link>
        </div> : <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          {error && <p className="border border-red-600/30 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
          <Field label={tr("Email")} required htmlFor="forgot-email">
            <input id="forgot-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email-input" />
          </Field>
          <button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full bg-esaia-blue px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
            {loading ? tr("Sending...") : tr("Send Reset Link")}
          </button>
        </form>}
    </AuthLayout>;
}
